const i18n_fields = {
  EN: [
    { key: 'img', label: 'Vender', sortable: false, sortDirection: 'desc', thClass: 'bg-primary text-white' },
    { key: 'os', label: 'OS', sortable: false, sortDirection: 'desc', thClass: 'bg-primary text-white' },
    { key: 'version', label: 'Version', sortable: false, class: 'text-center', thClass: 'bg-primary text-white' },
    { key: 'mmdb', label: 'Geo-IP', sortable: false, class: 'text-center', thClass: 'bg-primary text-white' },
    { key: 'cmd', label: 'CMD', sortable: false, sortDirection: 'desc', thClass: 'bg-primary text-white' },
  ],
  KO: [
    { key: 'img', label: '벤더사', sortable: false, sortDirection: 'desc', thClass: 'bg-primary text-white' },
    { key: 'os', label: '운영체제', sortable: false, sortDirection: 'desc', thClass: 'bg-primary text-white' },
    { key: 'version', label: '버전', sortable: false, class: 'text-center', thClass: 'bg-primary text-white' },
    { key: 'mmdb', label: 'Geo-IP', sortable: false, class: 'text-center', thClass: 'bg-primary text-white' },
    { key: 'cmd', label: '명령어', sortable: false, sortDirection: 'desc', thClass: 'bg-primary text-white' },
  ],
  JP : [
    { key: 'img', label: 'ベンダー', sortable: false, sortDirection: 'desc', thClass: 'bg-primary text-white' },
    { key: 'os', label: 'OS', sortable: false, sortDirection: 'desc', thClass: 'bg-primary text-white' },
    { key: 'version', label: 'バージョン', sortable: false, class: 'text-center', thClass: 'bg-primary text-white' },
    { key: 'mmdb', label: 'Geo-IP', sortable: false, class: 'text-center', thClass: 'bg-primary text-white' },
    { key: 'cmd', label: 'CMD', sortable: false, sortDirection: 'desc', thClass: 'bg-primary text-white' },
  ]
}

const _i18n_error = {
  agreement : {
    EN: `copy error`,
    KO: `copy error`,
    JP: `コピーエラー`
  },
  copy_failed : {
    EN: `copy failed`,
    KO: `copy failed`,
    JP: `コピー失敗`
  },
  multiple_length : {
    EN: `Select an agent to install`,
    KO: `Select an agent to install`,
    JP: `インストールするエージェントを選択する`
  },
  os : {
    EN: `Select an OS to agent install`,
    KO: `Select an OS to agent install`,
    JP: `エージェントをインストールするOSを選択する`
  },
  multiple : {
    EN: `Please select a web server`,
    KO: `Please select a web server`,
    JP: `Webサーバーを選択してください`
  },

  token_failed : {
    EN: `get token failed`,
    KO: `get token failed`,
    JP: `トークンを取得できませんでした`
  },
  download_failed: {
    EN: `ganeration failed`,
    KO: `ganeration failed`,
    JP: `生成に失敗しました`
  },
  getToken: {
    EN: `get token failed`,
    KO: `get token failed`,
    JP: `トークンを取得できませんでした`
  },

  copy_error: {
    EN: `Can not copy`,
    KO: `Can not copy`,
    JP: `コピー不可`
  },
  export: {
    EN: `copid failed, try agree`,
    KO: `copid failed, try agree`,
    JP: `コピーが失敗しました。同意してみてください`
  }
}

const _i18n_msg = {
  down_msg:{
    EN: `Create an installation script`,
    KO: `Create an installation script`,
    JP: `インストールスクリプトを作成します`
  },
}

const _i18n_data = {
  i18n_fields,
  _i18n_error,
  _i18n_msg
}

export default _i18n_data